"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "MARKING_TYPE", {
  enumerable: true,
  get: function () {
    return _Label.MARKING_TYPE;
  }
});
Object.defineProperty(exports, "STYLE_TYPE", {
  enumerable: true,
  get: function () {
    return _common.STYLE_TYPE;
  }
});
exports.TextArea = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _common = require("b2b-components/theme/components/Form/common");
var _Label = require("b2b-components/theme/components/Form/Label");
var _getComponentDataAttributes = require("b2b-components/utils/getComponentDataAttributes");
var _upperCase = require("b2b-components/utils/upperCase");
var _classnames = _interopRequireDefault(require("classnames"));
var _Error = require("../../common/Error");
var _Info = require("../../common/Info");
require("./TextArea.scss");
const TextArea = _ref => {
  let {
    dataAttributes,
    textareaId,
    autoGrowWrapperRef,
    autocomplete,
    className,
    maxLength,
    maxRowsAutoGrow,
    onBlur,
    onChange,
    onFocus,
    onInput,
    refCallback,
    error = null,
    hasFocus = false,
    info = null,
    isAutoGrow = false,
    isDisabled = false,
    rows = 2,
    markingType = _Label.MARKING_TYPE.none,
    styleType = _common.STYLE_TYPE.outlined,
    text = {
      label: '',
      placeholder: '',
      required: '*',
      optional: '(optional)'
    },
    value = ''
  } = _ref;
  const rootClassName = (0, _classnames.default)('cds-Form-Input', `cds-Form-Input--${(0, _upperCase.upperCaseFirst)(styleType)}`, {
    'cds-Form-Input--Error': error
  }, className);
  const labelClassName = (0, _classnames.default)('cds-Form-Label', 'cds-TextArea-Label', {
    'cds-TextArea-Label--Top': styleType === _common.STYLE_TYPE.underlinedFloatingLabel && (hasFocus || !!value)
  });
  const autoGrowWrapperClassName = (0, _classnames.default)('cds-Form-AutoGrowWrapper', {
    [`cds-Form-AutoGrowWrapper--maxRows${maxRowsAutoGrow || ''}`]: maxRowsAutoGrow
  });
  const textArea = () => /*#__PURE__*/_react.default.createElement("textarea", (0, _extends2.default)({}, (0, _getComponentDataAttributes.getComponentDataAttributes)(dataAttributes), {
    autoComplete: autocomplete,
    className: "cds-TextArea",
    id: textareaId,
    disabled: isDisabled,
    maxLength: maxLength,
    onBlur: onBlur,
    onChange: onChange,
    onFocus: onFocus,
    onInput: onInput,
    placeholder: text.placeholder,
    ref: input => input && refCallback?.(input),
    rows: rows,
    value: value
  }));
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: rootClassName
  }, text.label && /*#__PURE__*/_react.default.createElement(_Label.Label, {
    markingType: markingType,
    text: text,
    className: labelClassName,
    htmlFor: textareaId
  }, text.label), isAutoGrow && /*#__PURE__*/_react.default.createElement("div", {
    className: autoGrowWrapperClassName,
    ref: autoGrowWrapperRef
  }, textArea()), !isAutoGrow && textArea(), error && /*#__PURE__*/_react.default.createElement(_Error.Error, null, error), info && /*#__PURE__*/_react.default.createElement(_Info.Info, null, info)));
};
exports.TextArea = TextArea;
//# sourceMappingURL=TextArea.js.map